// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function accidentTypeReducer(state = [], action) {
    
    switch (action.type) {
      
        case types.LOGOUT:
            return []
        case types.LOAD_ACCIDENT_TYPE_SUCCESS:
            return action.accidentTypes;

        default:
            return state;
    };
};
